<header class="ui-top-bar" role="banner">
  <div class="ui-top-bar__left">
    @if (breadcrumbItems().length > 0) {
      <ui-breadcrumb [items]="breadcrumbItems()" />
    }
  </div>
</header>
